export default {
    state: () => ({
        data: { }
    }),
    mutations: {
        ['product/setState'](state, payload) {
            state.data = payload;
        },
        ['product/changeComments'](state, { items, pagination, routes, rating }) {
            state.data.product.comments = {
                ...state.data.product.comments,
                items,
                pagination,
                routes,
            }
            if (rating?.rating !== undefined) {
                state.data.product.rating = rating?.rating;
            }
        },
        ['product/addMoreComments'](state, { items, pagination, routes }) {
            state.data.product.comments = {
                items: [...state.data.product.comments.items, ...items ],
                pagination,
                routes,
            }
        },
    },
    actions: {
        async ['product/getPageData'] ({ commit }, payload) {
            try {
                const { data, status } = await axios.get(payload, { params: { api: 'y' } });

                if (status !== 200) {
                    throw `bad request response ${ payload }?api=y \n status: ${ status }`;
                }
                commit('product/setState', data);
                return true;
            } catch (err) {
                console.error(err);
            }
        },
        async ['product/addComment'] ({ commit, state }, payload) {
            try {
                const { action, path } = state.data.product.comments.routes.setComment;
                let formData = payload;

                if (action && path) {
                    formData.append('action', action);
                    formData.append('hidePageKey', 'Y');
                    const { status, data } = await axios.post(path, formData);

                    if (status !== 200) {
                        throw `bad request response status: ${ status } \n url: ${ path }`;
                    }
                    if (!data.errors) {
                        commit('product/changeComments', data);
                    }
                    return data;
                } else {
                    throw `action: ${ action } or path: ${ path } is empty`;
                }

            } catch (err) {
                console.error(err);
            }
        },
        async ['product/likeComment'] ({ commit, state, getters }, params) {
            try {
                const { action, path } = state.data.product.comments.routes.likeComment;
                const id = getters['product/id'];
                const { pageNumber } = state.data.product.comments.pagination;

                if (action && path) {
                    const requestData = { ...params, action, id, page: +pageNumber }

                    const { status, data } = await axios.post(path, requestData);

                    if (status !== 200) {
                        throw `bad request response status: ${ status } \n url: ${ path }`;
                    }

                    commit('product/changeComments', data);
                    return true;
                } else {
                    throw `action: ${ action } or path: ${ path } is empty`;
                }

            } catch (err) {
                console.error(err);
            }
        },
        // async ['product/addSubComment'] ({ commit, state }, payload) {
        //     try {
        //         const { action, path } = state.data.product.comments.routes.setComment;
        //         let formData = payload;
        //
        //         if (action && path) {
        //             formData.append('action', action);
        //             const { status, data } = await axios.post(path, formData);
        //
        //             if (status !== 200) {
        //                 throw `bad request response status: ${ status } \n url: ${ path }`;
        //             }
        //
        //             commit('product/changeComments', data);
        //             return true;
        //         } else {
        //             throw `action: ${ action } or path: ${ path } is empty`;
        //         }
        //
        //     } catch (err) {
        //         console.error(err);
        //     }
        // },
        async ['product/changePagination'] ({ commit, state, getters }, payload) {
            try {
                const { path, action } = state.data.product.comments.routes.getComments;
                const id = getters['product/id'];
                const { page } = payload;

                const { status, data } = await axios.get(path, {
                    params: {
                        id,
                        action,
                        page,
                        hidePageKey : 'Y'
                    }
                });

                if (status !== 200) {
                    throw `bad request response status: ${ status } \n url: ${ path }`;
                }

                commit('product/changeComments', data);
            } catch (err) {
                console.error(err);
            }
        },
        async ['product/addMorePagination'] ({ commit, state, getters }) {
            try {
                const { path, action } = state.data.product.comments.routes.getComments;
                const { pageNumber } = state.data.product.comments.pagination;
                const id = getters['product/id'];

                const { status, data } = await axios.get(path, {
                    params: {
                        page: +pageNumber + 1,
                        id,
                        action,
                        hidePageKey : 'Y'
                    }
                });
                if (status !== 200) {
                    throw `bad request response status: ${ status } \n url: ${ path }`;
                }

                commit('product/addMoreComments', data);
            } catch (err) {
                console.error(err);
            }
        },
    },
    getters: {
        ['product/id']: ({ data: { product } }) => {
            return product?.offer?.id || product?.id;
        },
    }
}